import { useEffect, useRef, useState } from 'react'
import './StatsSection.css'

function AnimatedNumber({ target, duration = 1800 }) {
  const [val, setVal] = useState(0)
  const ref = useRef(null)
  useEffect(() => {
    const el = ref.current
    if (!el) return
    const obs = new IntersectionObserver((entries) => {
      entries.forEach((e) => {
        if (e.isIntersecting) {
          let start = null
          const update = (now) => {
            if (!start) start = now
            const p = Math.min((now - start) / duration, 1)
            const eased = 1 - Math.pow(1 - p, 3)
            setVal(Math.round(eased * target))
            if (p < 1) requestAnimationFrame(update)
          }
          requestAnimationFrame(update)
          obs.disconnect()
        }
      })
    }, { threshold: 0.3 })
    obs.observe(el)
    return () => obs.disconnect()
  }, [target, duration])
  return <span ref={ref}>{val}</span>
}

export default function StatsSection() {
  return (
    <div className="stats-section">
      <div className="stats-grid">
        <div className="stat-item">
          <div className="stat-number"><AnimatedNumber target={25} />+</div>
          <div className="stat-label">Projetos entregues</div>
        </div>
        <div className="stat-item">
          <div className="stat-number"><AnimatedNumber target={7} /></div>
          <div className="stat-label">Cidades atendidas</div>
        </div>
        <div className="stat-item">
          <div className="stat-number">99.<span style={{ color: 'var(--accent)' }}>7</span>%</div>
          <div className="stat-label">Uptime médio</div>
        </div>
        <div className="stat-item">
          <div className="stat-number" style={{ fontSize: 28 }}>Gestão&nbsp;<span style={{ color: 'var(--accent)' }}>360°</span></div>
          <div className="stat-label">Visão integrada</div>
        </div>
      </div>
    </div>
  )
}
